import React, { Component } from 'react';
import { Input, Button, Confirm, Modal, Popup, Dropdown, Progress, Transition } from 'semantic-ui-react'
import axios from 'axios'
import { AutoSizer, Column, Table } from 'react-virtualized'
import 'react-virtualized/styles.css';
import './testStyles.css'

const headerStyle = {
  textTransform: 'none'
}
const defaultRowStyle = {
  background: 'white',
  borderBottom: '1px solid #4c4c4c'
}

class testThree extends Component {
  constructor(props) {
    super(props);
    this.state = {
      testThreeState: [],
      openConfirmBox: false,
      submitRow: 0,
      progressBarInd: 0,
      progressBarTot: 1,
      itemError: [0, 0, 0, 0, 0, 0],
      wholesaleError: [0, 0, 0, 0, 0, 0],
      asinError: [0, 0, 0, 0, 0, 0],
      passInd: [false, false, false, false, false, false],
      testTotalCount: [-1, -1, -1, -1, -1, -1],
      popUpOpenInd: [false, false, false, false, false, false]
    }

    this.submitRowAnswers = this.submitRowAnswers.bind(this)
  }

  async componentWillMount() {
    var self = this;
    //console.log("MOUNTING")
    await axios.get('/api/testInfo', {
      params: {
        testNumber: 3
      }
    })
    .then(function (res, err) {
      self.setState({testThreeState: res.data})
    })

    let tempUserId = this.props.getCookie("loggedInId")
    const {itemError, wholesaleError, asinError, passInd} = this.state
    var fullInputAnswersForTest

    await axios.get('/api/queryFullTestAnswers', {
      params: {
        User_Id: tempUserId,
        CorrectAnswerIds: [13, 14, 15, 16, 17, 18]
      }
    })
    .then(function (res, err) {
      fullInputAnswersForTest = res.data
    })

    var testThreeState = this.state.testThreeState
    this.setState({progressBarTot: fullInputAnswersForTest.length})

    for (let i = 0; i < fullInputAnswersForTest.length; i++) {
      let currentAnswer = fullInputAnswersForTest[i]
      var rowResults
      var shouldQuery = false

      if (i + 1 < fullInputAnswersForTest.length) {
        if (fullInputAnswersForTest[i + 1].CorrectAnswers_Id !== currentAnswer.CorrectAnswers_Id) {
          shouldQuery = true
        } else {rowResults = "skip"; shouldQuery = false;}
      } else {
        shouldQuery = true
      }

      if (shouldQuery) {
        await axios.get('/api/testCheckAnswers', {
          params: {
            Title: testThreeState[currentAnswer.CorrectAnswers_Id - 13].Title,
            ItemIdentifier: currentAnswer.ItemIdentifier,
            WholesalePrice: currentAnswer.WholesalePrice,
            ItemsPerAsin: currentAnswer.ItemsPerAsin,
            Status: currentAnswer.Status,
            testNumber: 3
          }
        })
        .then(function(res, err) {
          rowResults = res.data
        })
      }

      if (rowResults !== "skip") {
        let AnswerId = currentAnswer.CorrectAnswers_Id - 13
        let testTotalCount = this.state.testTotalCount

        testTotalCount[AnswerId] = AnswerId
        itemError[AnswerId] = !rowResults.ItemIdentifier
        wholesaleError[AnswerId] = !rowResults.WholesalePrice
        asinError[AnswerId] = !rowResults.ItemsPerAsin

        if (currentAnswer.Pass_Ind) {
          passInd[AnswerId] = true
        }
        //console.log(itemError, wholesaleError, asinError)
        this.setState({itemError: itemError, wholesaleError: wholesaleError, asinError: asinError, passInd: passInd, progressBarInd: i, testTotalCount: testTotalCount})
        if (!this.props.hasLoadedTest[2]){
          this.props.incrementEntries(itemError[AnswerId], wholesaleError[AnswerId], asinError[AnswerId], true)
        } else {
          this.props.testPorgressToNextTest()
        }

        testThreeState[AnswerId].Status = currentAnswer.Status
        testThreeState[AnswerId].itemidentifier = currentAnswer.ItemIdentifier
        testThreeState[AnswerId].manufacturerdesc = currentAnswer.ManufacturerDescription
        testThreeState[AnswerId].wholesale = currentAnswer.WholesalePrice
        testThreeState[AnswerId].itemsperasin = currentAnswer.ItemsPerAsin
        testThreeState[AnswerId].notes = currentAnswer.Notes

      }
    }

    let progressBarTot = this.state.progressBarTot
    this.setState({testThreeState: testThreeState, progressBarInd: progressBarTot + 1})
    this.props.changeLoadedTest(3)
  }

  handleChange = (e, { id, value }) => {
    var num = id.substring(id.length - 1)
    var array = this.state.testThreeState
    var objKey = id.substring(0, id.length - 1);
    array[num][objKey] = value
    this.setState({ testThreeState: array })
  }

  handleChangeStatus = (e, {id, value}) => {
    const num = id.substring(id.length - 1)
    var array = this.state.testThreeState
    var popUpArray = this.state.popUpOpenInd
    const objKey = id.substring(0, id.length - 1);
    array[num][objKey] = value
    popUpArray[num] = false
    this.setState({ testThreeState: array, popUpOpenInd: popUpArray })
  }

  handleCancel = () => this.setState({ openConfirmBox: false })

  openPopUp = (e) => {
    const num = e.target.id.substring(e.target.id.length - 1)
    var popUpArray = this.state.popUpOpenInd
    popUpArray[num] = true
    this.setState({popUpOpenInd: popUpArray})
  }

  openConfirm = (e, {...props}) => this.setState({ openConfirmBox: true, submitRow: {...props}.id })

  async submitRowAnswers() {
    var self = this;
    self.setState({ openConfirmBox: false })
    //console.log(this.state.testThreeState[this.state.submitRow])
    //First need to verify that all answers are filled out
    var answers = self.state.testThreeState[self.state.submitRow]
    var itemError = self.state.itemError
    var wholesaleError = self.state.wholesaleError
    var asinError = self.state.asinError
    var passInd = self.state.passInd
    var testTotalCount = self.state.testTotalCount

    if (answers.itemidentifier === undefined) { answers.itemidentifier = "" }
    if (answers.wholesale === undefined) { answers.wholesale = "" }
    if (answers.itemsperasin === undefined) { answers.itemsperasin = "" }
    if (answers.manufacturerdesc === undefined) { answers.manufacturerdesc = "" }
    if (answers.notes === undefined) { answers.notes = "" }
    if (answers.Status === undefined) { answers.Status = "Go" }

    var tempUsername = this.props.getCookie("loggedInId")

    var didPass = 0
    var answerId = 0

    await axios.get('/api/testCheckAnswers', {
      params: {
        Title: answers.Title,
        ItemIdentifier: answers.itemidentifier,
        WholesalePrice: answers.wholesale,
        ItemsPerAsin: answers.itemsperasin,
        Status: answers.Status,
        testNumber: 3
      }
    })
    .then(function (res, err) {
      //console.log(res.data)
      if (itemError[self.state.submitRow] !== !res.data.ItemIdentifier && itemError[self.state.submitRow] !== 0) {
        self.props.incrementEntries(false, 0, 0, false)
      }
      if (wholesaleError[self.state.submitRow] !== !res.data.WholesalePrice && wholesaleError[self.state.submitRow] !== 0) {
        self.props.incrementEntries(0, false, 0, false)
      }
      if (asinError[self.state.submitRow] !== !res.data.ItemsPerAsin && asinError[self.state.submitRow] !== 0) {
        self.props.incrementEntries(0, 0, false, false)
      }

      itemError[self.state.submitRow] = !res.data.ItemIdentifier
      wholesaleError[self.state.submitRow] = !res.data.WholesalePrice
      asinError[self.state.submitRow] = !res.data.ItemsPerAsin
      answerId = res.data.answerId
      if (res.data.ItemIdentifier === true && res.data.WholesalePrice === true && res.data.ItemsPerAsin === true) {
        didPass = 1
        passInd[self.state.submitRow] = true
      }
      //console.log(itemError, wholesaleError, asinError)
      self.setState({itemError: itemError, wholesaleError: wholesaleError, asinError: asinError})
      //console.log(answers)
    })

    var curDate = new Date();
    await axios.post('/api/inputAnswers', {
      CorrectAnswers_Id: answerId,
      Status: answers.Status,
      ItemIdentifier: answers.itemidentifier,
      ManufacturerDescription: answers.manufacturerdesc,
      WholesalePrice: answers.wholesale,
      ItemsPerAsin: answers.itemsperasin,
      Notes: answers.notes,
      User_Id: tempUsername,
      Date: curDate,
      Pass_Ind: didPass
    })
    .then(function (res, err) {
      if (err) throw err;
      //console.log(res)
    })

    await axios.get('/api/queryInputAnswers', {
      params: {
        User_Id: tempUsername,
        CorrectAnswers_Id: answerId
      }
    })
    .then(function (res, err) {
      if (err) throw err;
      for (let i = 0; i < res.data.length; i++) {
        let correctAnswerId = res.data[i].CorrectAnswers_Id - 13
        if (correctAnswerId !== testTotalCount[correctAnswerId]) {
          testTotalCount[correctAnswerId] = correctAnswerId
          self.props.incrementEntries(itemError[correctAnswerId], wholesaleError[correctAnswerId], asinError[correctAnswerId], true)
        }
      }

      self.setState({testTotalCount: testTotalCount})
    })
    
  }

  parentManufacturerField = ({...props}) => {
    let rowNumber = {...props}.rowIndex
    let link = "#"
    if (this.state.testThreeState[rowNumber].PriceListLink) {
      link = this.state.testThreeState[rowNumber].PriceListLink
    }
    let cellReturn = <div>
      <a rel="noopener noreferrer" target="_blank" href={link}>{this.state.testThreeState[rowNumber].ParentManufacturer}</a>
    </div>
    return cellReturn
  }
  titleField = ({...props}) => {
    let rowNumber = {...props}.rowIndex
    let link = "#"
    if (this.state.testThreeState[rowNumber].Asin) {
      link = ("https://www.amazon.com/dp/" + this.state.testThreeState[rowNumber].Asin)
    }
    let cellReturn = <div>
      <Popup
        trigger={<a rel="noopener noreferrer" target="_blank" href={link}>{this.state.testThreeState[rowNumber].Title}</a>}
        content={this.state.testThreeState[rowNumber].Title}
        wide
        size={"small"}
      />
    </div>
    return cellReturn
  }
  statusDropdown = ({...props}) => {
    let rowNumber = {...props}.rowIndex
    let rowInputId = "Status" + rowNumber
    let cellReturn = <div>
      <Popup 
        trigger={<div id={rowNumber}>{this.state.testThreeState[rowNumber].Status === undefined ? "Go" : this.state.testThreeState[rowNumber].Status}</div>} 
        on='click'
        open={this.state.popUpOpenInd[rowNumber]}
        onOpen={this.openPopUp}
      >
        <Popup.Header>Change Status</Popup.Header>
          <Popup.Content>
            <Dropdown id={rowInputId} selection
              placeholder="Go"
              value={this.state.testThreeState[rowNumber].Status === undefined ? "" : this.state.testThreeState[rowNumber].Status}
              onChange={this.handleChangeStatus}
              options={[{text: "Go", value: "Go"}, {text: "Couldn't Find in Price List", value: "Couldn't Find in Price List"}]}
            />
          </Popup.Content>
        </Popup>
      </div>
    return cellReturn
  }
  itemIdentifierInput = ({...props}) => {
    let rowNumber = {...props}.rowIndex
    let rowInputId = "itemidentifier" + rowNumber
    let isDisabled = false
    let backgroundColor = {}
    if (this.state.testThreeState[rowNumber].Status === "Couldn't Find in Price List") {
      isDisabled = true
      if (this.state.itemError[rowNumber] === false) {
        backgroundColor = {background: '#00ff0044'}
      }
    } else if (this.state.itemError[rowNumber] === false) {
      isDisabled = true
      backgroundColor = {background: '#00ff0044'}
    }
    let cellReturn = <div style={backgroundColor}>
        <Input id={rowInputId} placeholder="Item Identifier..." size="small" fluid error={this.state.itemError[rowNumber]} 
          disabled={isDisabled}
          value={this.state.testThreeState[rowNumber].itemidentifier === undefined ? "" : this.state.testThreeState[rowNumber].itemidentifier} 
          onChange={this.handleChange}/>
      </div>
    return cellReturn
  } 
  manufacDescInput = ({...props}) => {
    let rowNumber = {...props}.rowIndex
    let rowInputId = "manufacturerdesc" + rowNumber
    let isDisabled = false
    let backgroundColor = {}
    if (this.state.testThreeState[rowNumber].Status === "Couldn't Find in Price List") {
      isDisabled = true
      if (this.state.passInd[rowNumber]) {
        backgroundColor = {background: '#00ff0044'}
      }
    } else if (this.state.passInd[rowNumber]) {
      isDisabled = true
      backgroundColor = {background: '#00ff0044'}
    }
    let cellReturn = <div style={backgroundColor}>
        <Input id={rowInputId} placeholder="Manufacturer Description..." size="small" fluid 
          disabled={isDisabled}
          value={this.state.testThreeState[rowNumber].manufacturerdesc === undefined ? "" : this.state.testThreeState[rowNumber].manufacturerdesc} 
          onChange={this.handleChange}/>
      </div>
    return cellReturn
  } 
  wholePriceInput = ({...props}) => {
    let rowNumber = {...props}.rowIndex
    let rowInputId = "wholesale" + rowNumber
    let isDisabled = false
    let backgroundColor = {}
    if (this.state.testThreeState[rowNumber].Status === "Couldn't Find in Price List") {
      isDisabled = true
      if (this.state.wholesaleError[rowNumber] === false) {
        backgroundColor = {background: '#00ff0044'}
      }
    } else if (this.state.wholesaleError[rowNumber] === false) {
      isDisabled = true
      backgroundColor = {background: '#00ff0044'}
    }
    let cellReturn = <div style={backgroundColor}>
        <Input id={rowInputId} placeholder="Wholesale Price..." size="small" fluid error={this.state.wholesaleError[rowNumber]}
          disabled={isDisabled}
          value={this.state.testThreeState[rowNumber].wholesale === undefined ? "" : this.state.testThreeState[rowNumber].wholesale} 
          onChange={this.handleChange}
          type={"number"}/>
      </div>
    return cellReturn
  } 
  itemsPerAsinInput = ({...props}) => {
    let rowNumber = {...props}.rowIndex
    let rowInputId = "itemsperasin" + rowNumber
    let isDisabled = false
    let backgroundColor = {}
    if (this.state.testThreeState[rowNumber].Status === "Couldn't Find in Price List") {
      isDisabled = true
      if (this.state.asinError[rowNumber] === false) {
        backgroundColor = {background: '#00ff0044'}
      }
    } else if (this.state.asinError[rowNumber] === false) {
      isDisabled = true
      backgroundColor = {background: '#00ff0044'}
    }
    let cellReturn = <div style={backgroundColor}>
        <Input id={rowInputId} placeholder="Items Per Asin..." size="small" fluid error={this.state.asinError[rowNumber]}
          disabled={isDisabled}
          value={this.state.testThreeState[rowNumber].itemsperasin === undefined ? "" : this.state.testThreeState[rowNumber].itemsperasin} 
          onChange={this.handleChange}
          type={"number"}/>
      </div>
    return cellReturn
  } 
  notesInput = ({...props}) => {
    let rowNumber = {...props}.rowIndex
    let rowInputId = "notes" + rowNumber
    let isDisabled = false
    let backgroundColor = {}
    if (this.state.testThreeState[rowNumber].Status === "Couldn't Find in Price List") {
      isDisabled = true
      if (this.state.passInd[rowNumber]) {
        backgroundColor = {background: '#00ff0044'}
      }
    } else if (this.state.passInd[rowNumber]) {
      isDisabled = true
      backgroundColor = {background: '#00ff0044'}
    }
    let cellReturn = <div style={backgroundColor}>
        <Input id={rowInputId} placeholder="Notes..." size="small" fluid 
          disabled={isDisabled}
          value={this.state.testThreeState[rowNumber].notes === undefined ? "" : this.state.testThreeState[rowNumber].notes} 
          onChange={this.handleChange}/>
      </div>
    return cellReturn
  } 

  buttonRow = ({...props}) => {
    var cellReturn = <div>
        <Button id={{...props}.rowIndex} fluid size={'tiny'} onClick={this.openConfirm} >Submit</Button>
      </div>
    return cellReturn
  }

  changeRowClass({ index }) {
    if (index < 0) {
      return headerStyle
    }
    return defaultRowStyle
  }


  render() {
    const { testThreeState, progressBarInd, progressBarTot } = this.state
    var TableorLoading = <div>Loading test...</div>
    if (testThreeState.length > 0) {
      TableorLoading = <AutoSizer disableHeight>
          {({ width }) => (
            <Table
              ref="testThree"
              headerHeight={30}
              height={270}
              rowCount={6}
              rowGetter={({ index }) => testThreeState[index]}
              rowHeight={40}
              rowStyle={this.changeRowClass}
              width={width}
            >
            <Column
              label='Parent Manufacturer'
              dataKey='ParentManufacturer'
              width={220}
              cellRenderer={this.parentManufacturerField}
            />
            <Column
              width={300}
              label='Title'
              dataKey='Title'
              cellRenderer={this.titleField}
            />
            <Column
              width={75}
              label='Status'
              dataKey='Status'
              cellRenderer={this.statusDropdown}
            />
            <Column
              width={180}
              label='Item Identifier'
              dataKey='itemidentifier'
              cellRenderer={this.itemIdentifierInput}
            />
            <Column
              width={260}
              label='Manufacturer Description'
              dataKey='manufacturerdesc'
              cellRenderer={this.manufacDescInput}
            />
            <Column
              width={180}
              label='Wholesale Price'
              dataKey='wholesale'
              cellRenderer={this.wholePriceInput}
            />
            <Column
              width={180}
              label='Items Per Asin'
              dataKey='itemsperasin'
              cellRenderer={this.itemsPerAsinInput}
            />
            <Column
              width={170}
              label='Notes'
              dataKey='notes'
              cellRenderer={this.notesInput}
            />
            <Column 
              width={160} 
              label='Asin' 
              dataKey='Asin'
            /> 
            <Column
              width={110}
              dataKey='submit'
              cellRenderer={this.buttonRow}
            />
            </Table>
          )}
        </AutoSizer>;
    }

    if (this.props.testStepsUnlock !== undefined) {
      if (this.props.testStepsUnlock[2]){
        var videoModal = <Modal dimmer={"blurring"} closeIcon trigger={<Button style={{marginTop: 20}}>Help Video</Button>}>
          <Modal.Header>How to get information for test 3</Modal.Header>
          <Modal.Content>
            <iframe title="testThreeVideo" width="850" height="500" src="https://www.youtube.com/embed/IVrq7FoSnAA" frameborder="0" gesture="media" allow="encrypted-media" allowfullscreen></iframe>
          </Modal.Content>
        </Modal>;
      } else { var videoModal = <div style={{marginTop: 20}}>Help video will be provided after all lines have been submitted</div> }
    } else { var videoModal = <div style={{marginTop: 20}}>Help video will be provided after all lines have been submitted</div> }

    var submitRow = 'Are you sure you want to submit your answers on row: ' + (this.state.submitRow + 1)
    var ConfirmBox = <Confirm
        open={this.state.openConfirmBox}
        content={submitRow}
        cancelButton='No!'
        confirmButton='Yes!'
        onCancel={this.handleCancel}
        onConfirm={this.submitRowAnswers}
      />

    var ProgressBar = <Transition visible={progressBarInd !== progressBarTot + 1} animation='fade down' duration={500}>
      <Progress value={progressBarInd} total={progressBarTot} size='tiny' color='blue' active />
      </Transition>

    return (
      <div>
        <div style={{position: 'absolute', width: '100%', top: '-1px'}}>{ProgressBar}</div>
        <div style={{position: 'absolute', top: '20%', left: '1%', width: '98%'}}>
          {TableorLoading}
          {videoModal}
          {ConfirmBox}
        </div>
      </div>
    );
  }
}

export default testThree;



// WEBPACK FOOTER //
// ./src/pages/testpages/testthree.js